import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/monalisa.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/mondrian1.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/typo-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/xlogo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["BetaTestForm"] */ "/app/src/components/forms/beta-test-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/app/src/components/forms/contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketGrowthSection"] */ "/app/src/components/sections/market-growth-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/decorative-box.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DonutChart"] */ "/app/src/components/ui/donut-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyVideo"] */ "/app/src/components/ui/lazy-video.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/motion-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/app/src/components/ui/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhoneSlider"] */ "/app/src/components/ui/phone-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Splash"] */ "/app/src/components/ui/splash.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamCard"] */ "/app/src/components/ui/team-card.tsx");
